import React from 'react';
import { User } from '../../types/auth';
import { displayName } from './navigation';

/** Red app mark, with the wordmark unless `markOnly` */
export const Brand: React.FC<{ markOnly?: boolean; className?: string }> = ({ markOnly = false, className = '' }) => (
  <span className={`inline-flex items-center gap-2.5 ${className}`}>
    <span
      aria-hidden="true"
      className="inline-flex h-7 w-7 flex-shrink-0 items-center justify-center rounded-[9px] bg-primary-600 text-[15px] font-semibold leading-none text-white shadow-[inset_0_-1px_0_rgba(0,0,0,0.15)]"
    >
      S
    </span>
    {markOnly ? (
      <span className="sr-only">Staketory</span>
    ) : (
      <span className="text-[17px] font-medium tracking-[-0.02em] text-ink">Staketory</span>
    )}
  </span>
);

export const UserAvatar: React.FC<{ user: User | null | undefined; size?: 'sm' | 'md' | 'lg' }> = ({
  user,
  size = 'md',
}) => {
  const initial = (user?.firstName?.[0] || user?.email?.[0] || '?').toUpperCase();
  const sizes = { sm: 'h-7 w-7 text-[12px]', md: 'h-8 w-8 text-[13px]', lg: 'h-14 w-14 text-[20px]' };
  return (
    <span
      aria-hidden="true"
      title={displayName(user)}
      className={`inline-flex flex-shrink-0 items-center justify-center rounded-full bg-ink font-medium text-white ${sizes[size]}`}
    >
      {initial}
    </span>
  );
};
